import { tracking } from '@iwoca/frontend-tracking-library';
import { PostDocumentUploadResponse } from '@iwoca/lapi-client/edge';

import { TDocumentTypeDE } from '../../../lapiOverrideTypesDE';

export const trackDocumentUploadClicked = (
  documentType:
    PostDocumentUploadResponse['data']['document_type'] | TDocumentTypeDE,
) => {
  switch (documentType) {
    case 'aged debtor report':
      tracking.ampli.agedDebtorReportUploadClicked();
      break;
    case 'bank statement':
      tracking.ampli.uploadBankStatementsClicked();
      break;
    case 'business plan':
      tracking.ampli.businessPlanUploadClicked();
      break;
    case 'business accounts':
      tracking.ampli.companyAccountsUploadClicked();
      break;
    case 'management accounts':
      tracking.ampli.managementAccountsUploadClicked();
      break;
    case 'vat return':
      tracking.ampli.vatReturnsUploadClicked();
      break;
  }
};

export const trackDocumentUploaded = (
  documentType:
    PostDocumentUploadResponse['data']['document_type'] | TDocumentTypeDE,
) => {
  switch (documentType) {
    case 'aged debtor report':
      tracking.ampli.agedDebtorReportUploaded();
      break;
    case 'bank statement':
      tracking.ampli.bankStatementsUploaded();
      break;
    case 'business plan':
      tracking.ampli.businessPlanUploaded();
      break;
    case 'business accounts':
      tracking.ampli.companyAccountsUploaded();
      break;
    case 'management accounts':
      tracking.ampli.managementAccountsUploaded();
      break;
    case 'vat return':
      tracking.ampli.vatReturnsUploaded();
      break;
  }
};
